<template>
  <span class="group relative flex h-5 w-5 items-center justify-center rounded-full border">
    <span class="text-xs" :class="iconClass"></span>
    <span
      class="absolute left-0 z-50 ml-5 hidden whitespace-nowrap bg-white px-1 text-sm leading-loose group-hover:block"
    >
      <slot />
    </span>
  </span>
</template>

<script>
export default {
  props: {
    iconClass: {
      required: true,
    },
  },
}
</script>
